// depricated
export const getCurrentPathname = props => {
    if (process.env.IS_WEB) {
        const { route } = props;
        return route.path;
    }

    const { router } = props;
    debugger;
    const pathname = router.getCurrentLocation().pathname;
    return pathname;
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/utils/rn.helper.js